export enum MyAccountToggleSaveButtonInteractionSourceEnum {
  BUTTON_BAR = 'top',
  CAROUSEL_NUDGE = 'carousel',
  SAVE_SHARE_AREA = 'bottom',
  CARD = 'card',
}
